import { render } from "./FillableHtmlForm.vue?vue&type=template&id=b620be3a&scoped=true"
import script from "./FillableHtmlForm.vue?vue&type=script&lang=js"
export * from "./FillableHtmlForm.vue?vue&type=script&lang=js"

import "./FillableHtmlForm.vue?vue&type=style&index=0&id=b620be3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b620be3a"]])

export default __exports__